export enum STEPS {
  LANDING = 0,
  REG_FORM,
  CODE,
  ROLE,
  SUCCESS,
  PATIENT_ONLY,
}

export type TStepPaths = 'landing' | 'reg-form' | 'code' | 'role' | 'success' | 'patient-success';

export const PathMap: Record<TStepPaths, STEPS> = {
  landing: STEPS.LANDING,
  'reg-form': STEPS.REG_FORM,
  code: STEPS.CODE,
  role: STEPS.ROLE,
  success: STEPS.SUCCESS,
  'patient-success': STEPS.PATIENT_ONLY,
};

export type TPAthParams = {
  step?: TStepPaths;
};
